<template>
	<section class="other_page_banner banner_nxt_sec_touch">
		<div class="container">
			<div class="row">
				<div class="col-sm-7 order-2 order-md-1">
					<div class="ban_lt">
						<h5>
							{{ $t('new_ui.personal_deposit_page.section_banner.title.one') }}
						</h5>
						<h2>
							{{
								$t('new_ui.personal_deposit_page.section_banner.main_title.one')
							}}
						</h2>
						<p>
							{{
								$t('new_ui.personal_deposit_page.section_banner.paragraph.one')
							}}
						</p>

						<div
							class="ban_lt_btn d-flex justify-content-start align-items-center p-top"
						></div>
					</div>
				</div>
				<div class="col-sm-5 order-1 order-md-2">
					<div class="ban_rt">
						<img :src="img.image1" alt="Logo" />
					</div>
				</div>
			</div>
		</div>
	</section>

	<section class="seller_access deposit_mid">
		<div class="container">
			<div class="row">
				<div class="col-sm-12 border_dash">
					<div class="row">
						<div class="col-sm-12 col-xxl-6 col-xl-6 col-lg-6 col-md-12">
							<div class="seller_access_lt">
								<img :src="img.image2" alt="" />
							</div>
						</div>
						<div class="col-sm-12 col-xxl-6 col-xl-6 col-lg-6 col-md-12">
							<div class="seller_access_rt">
								<span>{{
									$t('new_ui.personal_deposit_page.seller_access.label')
								}}</span>
								<div class="seller_access_txt">
									<h4>
										{{
											$t(
												'new_ui.personal_deposit_page.seller_access.title.one',
											)
										}}<br />
										{{
											$t('new_ui.personal_deposit_page.seller_access.title.two')
										}}
										<span>{{
											$t(
												'new_ui.personal_deposit_page.seller_access.title.three',
											)
										}}</span>
									</h4>
									<p>
										{{
											$t(
												'new_ui.personal_deposit_page.seller_access.paragraph.one',
											)
										}}
									</p>
									<p>
										{{
											$t(
												'new_ui.personal_deposit_page.seller_access.paragraph.two',
											)
										}}
									</p>
									<div class="starting_to_btn">
										<a href="/auth/register">{{
											$t(
												'new_ui.personal_deposit_page.seller_access.cta_buttons.one',
											)
										}}</a>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>

	<section class="credit_system">
		<div class="container">
			<div class="row">
				<div class="col-sm-12">
					<div class="deposit_recipients">
						<span>{{
							$t('new_ui.personal_deposit_page.deposit_recipients.label')
						}}</span>
						<h5>
							{{
								$t('new_ui.personal_deposit_page.deposit_recipients.title.one')
							}}
							<span>{{
								$t('new_ui.personal_deposit_page.deposit_recipients.title.two')
							}}</span>
						</h5>
						<p>
							{{
								$t(
									'new_ui.personal_deposit_page.deposit_recipients.paragraph.one',
								)
							}}
						</p>
					</div>
				</div>
			</div>
			<div class="row d-none d-md-flex">
				<div class="col-sm-6">
					<div class="creditcard_system_inn credit_system_rt">
						<img class="d-block d-md-none" :src="img.image4" alt="" />
						<span>{{
							$t('new_ui.personal_deposit_page.credit_system_sec.label')
						}}</span>
						<div class="creditcard_system_txt">
							<h4>
								{{
									$t('new_ui.personal_deposit_page.credit_system_sec.title.one')
								}}
								<br /><span>{{
									$t('new_ui.personal_deposit_page.credit_system_sec.title.two')
								}}</span>
								{{
									$t(
										'new_ui.personal_deposit_page.credit_system_sec.title.three',
									)
								}}
								<span>{{
									$t(
										'new_ui.personal_deposit_page.credit_system_sec.title.four',
									)
								}}</span>
							</h4>
							<p>
								{{
									$t(
										'new_ui.personal_deposit_page.credit_system_sec.paragraph.one',
									)
								}}
							</p>
							<div class="starting_to_btn">
								<a href="/auth/register">{{
									$t(
										'new_ui.personal_deposit_page.credit_system_sec.cta_buttons',
									)
								}}</a>
							</div>
							<img class="d-none d-md-block" :src="img.image4" alt="" />
						</div>
					</div>
				</div>
				<div class="col-sm-6">
					<div class="creditcard_system_inn credit_system_rt">
						<img :src="img.image3" alt="" />
						<span>{{
							$t('new_ui.personal_deposit_page.credit_system_right_sec.label')
						}}</span>
						<div class="creditcard_system_txt">
							<h4>
								<span>{{
									$t(
										'new_ui.personal_deposit_page.credit_system_right_sec.title.one',
									)
								}}</span>
								{{
									$t(
										'new_ui.personal_deposit_page.credit_system_right_sec.title.two',
									)
								}}
								<span>{{
									$t(
										'new_ui.personal_deposit_page.credit_system_right_sec.title.three',
									)
								}}</span
								><br />
								{{
									$t(
										'new_ui.personal_deposit_page.credit_system_right_sec.title.four',
									)
								}}
							</h4>
							<p>
								{{
									$t(
										'new_ui.personal_deposit_page.credit_system_right_sec.paragraph.one',
									)
								}}
							</p>
							<div class="starting_to_btn">
								<a href="/auth/register">{{
									$t(
										'new_ui.personal_deposit_page.credit_system_right_sec.cta_buttons',
									)
								}}</a>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="row d-block d-md-none">
				<div class="col-sm-12 border_dash">
					<div class="row">
						<div class="enjoy_slider">
							<swiper
								:slides-per-view="1"
								:space-between="30"
								:loop="true"
								:pagination="{
									el: '.swiper-pagination-2',
									clickable: true,
								}"
								:autoplay="{ delay: 2000, disableOnInteraction: false }"
								:breakpoints="{
									0: { slidesPerView: 1 },
									600: { slidesPerView: 1.5 },
									768: { slidesPerView: 2 },
									1000: { slidesPerView: 3 },
									1200: { slidesPerView: 4.5 },
								}"
							>
								<swiper-slide>
									<div class="col-sm-6">
										<div class="creditcard_system_inn credit_system_rt">
											<img class="d-block d-md-none" :src="img.image4" alt="" />
											<span>{{
												$t(
													'new_ui.personal_deposit_page.credit_system_sec.label',
												)
											}}</span>
											<div class="creditcard_system_txt">
												<h4>
													{{
														$t(
															'new_ui.personal_deposit_page.credit_system_sec.title.one',
														)
													}}
													<br /><span>{{
														$t(
															'new_ui.personal_deposit_page.credit_system_sec.title.two',
														)
													}}</span>
													{{
														$t(
															'new_ui.personal_deposit_page.credit_system_sec.title.three',
														)
													}}
													<span>{{
														$t(
															'new_ui.personal_deposit_page.credit_system_sec.title.four',
														)
													}}</span>
												</h4>
												<p>
													{{
														$t(
															'new_ui.personal_deposit_page.credit_system_sec.paragraph.one',
														)
													}}
												</p>
												<div class="starting_to_btn">
													<a href="/auth/register">{{
														$t(
															'new_ui.personal_deposit_page.credit_system_sec.cta_buttons',
														)
													}}</a>
												</div>
												<img
													class="d-none d-md-block"
													:src="img.image4"
													alt=""
												/>
											</div>
										</div>
									</div>
								</swiper-slide>
								<swiper-slide>
									<div class="col-sm-6">
										<div class="creditcard_system_inn credit_system_rt">
											<img :src="img.image3" alt="" />
											<span>{{
												$t(
													'new_ui.personal_deposit_page.credit_system_right_sec.label',
												)
											}}</span>
											<div class="creditcard_system_txt">
												<h4>
													<span>{{
														$t(
															'new_ui.personal_deposit_page.credit_system_right_sec.title.one',
														)
													}}</span>
													{{
														$t(
															'new_ui.personal_deposit_page.credit_system_right_sec.title.two',
														)
													}}
													<span>{{
														$t(
															'new_ui.personal_deposit_page.credit_system_right_sec.title.three',
														)
													}}</span
													><br />
													{{
														$t(
															'new_ui.personal_deposit_page.credit_system_right_sec.title.four',
														)
													}}
												</h4>
												<p>
													{{
														$t(
															'new_ui.personal_deposit_page.credit_system_right_sec.paragraph.one',
														)
													}}
												</p>
												<div class="starting_to_btn">
													<a href="/auth/register">{{
														$t(
															'new_ui.personal_deposit_page.credit_system_right_sec.cta_buttons',
														)
													}}</a>
												</div>
											</div>
										</div>
									</div>
								</swiper-slide>
							</swiper>
							<!-- Move pagination outside swiper -->
							<div class="swiper-pagination-2"></div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
	<section class="newsletter_sec">
		<div class="container">
			<div class="row">
				<div class="col-sm-12 col-xxl-5 col-xl-5 col-lg-5 col-md-12">
					<div class="newsletter_lt">
						<span>{{
							$t('new_ui.personal_deposit_page.section_newsletter.label')
						}}</span>
						<div class="newsletter_txt">
							<h4>
								<span>{{
									$t(
										'new_ui.personal_deposit_page.section_newsletter.title.one',
									)
								}}</span>
								{{
									$t(
										'new_ui.personal_deposit_page.section_newsletter.title.two',
									)
								}}
							</h4>
						</div>
					</div>
				</div>
				<div class="col-sm-12 col-xxl-7 col-xl-7 col-lg-7 col-md-12">
					<div class="newsletter_rt">
						<p>
							{{
								$t(
									'new_ui.personal_deposit_page.section_newsletter.description.one',
								)
							}}
						</p>
						<form>
							<div class="news_mail">
								<div class="news_mail_lt">
									<input
										type="email"
										:placeholder="
											$t(
												'new_ui.personal_deposit_page.section_newsletter.form.placeholder',
											)
										"
									/>
								</div>
								<div class="news_mail_rt">
									<button type="submit" value="submit">
										{{
											$t(
												'new_ui.personal_deposit_page.section_newsletter.form.button',
											)
										}}
									</button>
								</div>
							</div>
						</form>
						<p class="mt-3">
							{{
								$t(
									'new_ui.personal_deposit_page.section_newsletter.description.two',
								)
							}}
						</p>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
import depositban from '@/assets/images/sub/deposit_ban.png';
import d1 from '@/assets/images/sub/d1.png';
import dr1 from '@/assets/images/sub/dr1.png';
import dr2 from '@/assets/images/sub/dr2.png';
import SwiperCore, { Autoplay, Pagination } from 'swiper';
SwiperCore.use([Autoplay, Pagination]);

export default {
	data: () => {
		return {
			img: {
				image1: depositban,
				image2: d1,
				image3: dr1,
				image4: dr2,
			},
		};
	},
};
</script>
